import { render, staticRenderFns } from "./nbn-ticket-details.vue?vue&type=template&id=791d316c&scoped=true"
import script from "./nbn-ticket-details.vue?vue&type=script&lang=js"
export * from "./nbn-ticket-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d316c",
  null
  
)

export default component.exports